"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsDarkModeEnabledOsDefault = exports.createMuiPaletteOptions = exports.createDefaultColorUseCases = exports.ultravioletPalette = exports.francePalette = exports.defaultPalette = void 0;
var changeColorOpacity_1 = require("../tools/changeColorOpacity");
__exportStar(require("../tools/changeColorOpacity"), exports);
exports.defaultPalette = {
    "focus": {
        "main": "#FF562C",
        "light": "#FF562C",
        "light2": "#FFAD99",
    },
    "dark": {
        "main": "#2C323F",
        "light": "#373E4F",
        "greyVariant1": "#242C39",
        "greyVariant2": "#5A6270",
        "greyVariant3": "#8A9099",
        "greyVariant4": "#B8BABF",
    },
    "light": {
        "main": "#F1F0EB",
        "light": "#FDFDFC",
        "greyVariant1": "#E6E6E6",
        "greyVariant2": "#C9C9C9",
        "greyVariant3": "#9E9E9E",
        "greyVariant4": "#747474",
    },
    "redError": {
        "main": "#CC0B0B",
        "light": "#FEECEB",
    },
    "greenSuccess": {
        "main": "#29CC2F",
        "light": "#EEFAEE",
    },
    "orangeWarning": {
        "main": "#FF8800",
        "light": "#FFF5E5",
    },
    "blueInfo": {
        "main": "#2196F3",
        "light": "#E9F5FE",
    },
};
exports.francePalette = __assign(__assign({}, exports.defaultPalette), { "focus": {
        "main": "#000091",
        "light": "#9A9AFF",
        "light2": "#E5E5F4",
    }, "dark": {
        "main": "#2A2A2A",
        "light": "#383838",
        "greyVariant1": "#161616",
        "greyVariant2": "#9C9C9C",
        "greyVariant3": "#CECECE",
        "greyVariant4": "#E5E5E5",
    }, "light": {
        "main": "#F1F0EB",
        "light": "#FDFDFC",
        "greyVariant1": "#E6E6E6",
        "greyVariant2": "#C9C9C9",
        "greyVariant3": "#9E9E9E",
        "greyVariant4": "#747474",
    } });
exports.ultravioletPalette = __assign(__assign({}, exports.defaultPalette), { "focus": {
        "main": "#067A76",
        "light": "#0AD6CF",
        "light2": "#AEE4E3",
    }, "dark": {
        "main": "#2D1C3A",
        "light": "#4A3957",
        "greyVariant1": "#22122E",
        "greyVariant2": "#493E51",
        "greyVariant3": "#918A98",
        "greyVariant4": "#C0B8C6",
    }, "light": {
        "main": "#F7F5F4",
        "light": "#FDFDFC",
        "greyVariant1": "#E6E6E6",
        "greyVariant2": "#C9C9C9",
        "greyVariant3": "#9E9E9E",
        "greyVariant4": "#747474",
    } });
function createDefaultColorUseCases(params) {
    var isDarkModeEnabled = params.isDarkModeEnabled, palette = params.palette;
    return {
        "typography": {
            "textPrimary": palette[isDarkModeEnabled ? "light" : "dark"].main,
            "textSecondary": palette[isDarkModeEnabled ? "dark" : "light"].greyVariant4,
            "textTertiary": palette[isDarkModeEnabled ? "dark" : "light"].greyVariant2,
            "textDisabled": palette[isDarkModeEnabled ? "dark" : "light"].greyVariant2,
            "textFocus": palette.focus[isDarkModeEnabled ? "light" : "main"],
        },
        "buttons": {
            "actionHoverPrimary": palette.focus[isDarkModeEnabled ? "light" : "main"],
            "actionHoverSecondary": isDarkModeEnabled
                ? palette.light.light
                : palette.dark.main,
            "actionHoverTernary": palette.light.main,
            "actionSelected": isDarkModeEnabled
                ? palette.dark.light
                : palette.light.greyVariant1,
            "actionActive": palette.focus[isDarkModeEnabled ? "light" : "main"],
            "actionDisabled": palette[isDarkModeEnabled ? "dark" : "light"].greyVariant3,
            "actionDisabledBackground": palette[isDarkModeEnabled ? "dark" : "light"].greyVariant1,
        },
        "surfaces": {
            "background": palette[isDarkModeEnabled ? "dark" : "light"].main,
            "surface1": palette[isDarkModeEnabled ? "dark" : "light"].light,
            "surface2": palette[isDarkModeEnabled ? "dark" : "light"].greyVariant1,
        },
        "alertSeverity": {
            "error": {
                "main": palette.redError.main,
                "background": isDarkModeEnabled
                    ? changeColorOpacity_1.changeColorOpacity({
                        "color": palette.redError.main,
                        "opacity": 0.2,
                    })
                    : palette.redError.light,
            },
            "success": {
                "main": palette.greenSuccess.main,
                "background": isDarkModeEnabled
                    ? changeColorOpacity_1.changeColorOpacity({
                        "color": palette.greenSuccess.main,
                        "opacity": 0.2,
                    })
                    : palette.greenSuccess.light,
            },
            "warning": {
                "main": palette.orangeWarning.main,
                "background": isDarkModeEnabled
                    ? changeColorOpacity_1.changeColorOpacity({
                        "color": palette.orangeWarning.main,
                        "opacity": 0.2,
                    })
                    : palette.orangeWarning.light,
            },
            "info": {
                "main": palette.blueInfo.main,
                "background": isDarkModeEnabled
                    ? changeColorOpacity_1.changeColorOpacity({
                        "color": palette.blueInfo.main,
                        "opacity": 0.2,
                    })
                    : palette.blueInfo.light,
            },
        },
    };
}
exports.createDefaultColorUseCases = createDefaultColorUseCases;
function createMuiPaletteOptions(params) {
    var isDarkModeEnabled = params.isDarkModeEnabled, palette = params.palette, useCases = params.useCases;
    return {
        "mode": isDarkModeEnabled ? "dark" : "light",
        "primary": {
            "main": palette.focus[isDarkModeEnabled ? "light" : "main"],
            "light": palette.focus.light2,
        },
        "secondary": {
            "main": useCases.typography.textPrimary,
            "light": useCases.typography.textSecondary,
        },
        "error": {
            "light": useCases.alertSeverity.error.background,
            "main": useCases.alertSeverity.error.main,
            "contrastText": useCases.typography.textPrimary,
        },
        "success": {
            "light": useCases.alertSeverity.success.background,
            "main": useCases.alertSeverity.success.main,
            "contrastText": useCases.typography.textPrimary,
        },
        "info": {
            "light": useCases.alertSeverity.info.background,
            "main": useCases.alertSeverity.info.main,
            "contrastText": useCases.typography.textPrimary,
        },
        "warning": {
            "light": useCases.alertSeverity.warning.background,
            "main": useCases.alertSeverity.warning.main,
            "contrastText": useCases.typography.textPrimary,
        },
        "text": {
            "primary": useCases.typography.textPrimary,
            "secondary": useCases.typography.textSecondary,
            "disabled": useCases.typography.textDisabled,
        },
        "divider": useCases.buttons.actionDisabledBackground,
        "background": {
            "paper": useCases.surfaces.surface1,
            "default": useCases.surfaces.background,
        },
        "action": {
            "active": useCases.buttons.actionActive,
            "hover": useCases.buttons.actionHoverPrimary,
            "selected": useCases.buttons.actionSelected,
            "disabled": useCases.buttons.actionDisabled,
            "disabledBackground": useCases.buttons.actionDisabledBackground,
            "focus": useCases.typography.textFocus,
        },
    };
}
exports.createMuiPaletteOptions = createMuiPaletteOptions;
function getIsDarkModeEnabledOsDefault() {
    return (window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);
}
exports.getIsDarkModeEnabledOsDefault = getIsDarkModeEnabledOsDefault;
//# sourceMappingURL=color.js.map